import React, { Fragment } from 'react';
import { DeleteButton, Toolbar } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import ConfirmChange from './Dialogs/ConfirmChange';
import DisabledSaveButton from './Buttons/DisabledSave';
import HistoryButton from './Buttons/HistoryButton';

const styles = createStyles({
  defaultToolbar: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
  }
});

type Props = {
  accessCheck: boolean,
  basePath: string,
  classes: any,
  id?: string,
  invalid?: boolean,
  record: any,
  resource: string,
  handleSubmitWithRedirect?: any,
  redirect?: string | boolean
};

const PermissionToolbar = (props: Props) => (
  <Toolbar>
    <Fragment>
      <div className={props.classes.defaultToolbar}>
        {props.accessCheck ? <ConfirmChange
          handleSubmitWithRedirect={props.handleSubmitWithRedirect}
          invalid={props.invalid}
          redirect={props.redirect} /> : <DisabledSaveButton />}
        <span>
          <HistoryButton
            basePath={props.basePath}
            id={props.id || (props.record && props.record.id)} />
          <DeleteButton
            basePath={props.basePath}
            record={props.record}
            resource={props.resource} />
        </span>
      </div>
    </Fragment>
  </Toolbar>
);

export default withStyles(styles)(PermissionToolbar);



// WEBPACK FOOTER //
// ./src/views/Common/Toolbar.tsx